import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { StrapiFile } from './strapi-file.model';

export class Document extends BitfStrapiModel {
  name: string;
  type: EDocumentType;
  file: StrapiFile;
  html: string;
  constructor(data: Partial<Document> = {}) {
    super({ data });
  }

  get serialised() {
    return {
      name: this.name,
      type: this.type,
      file: this.file,
      html: this.html,
    };
  }
}

export enum EDocumentType {
  TERMS_AND_CONDITIONS_CASADOC = 'TERMS_AND_CONDITIONS_CASADOC',
  TERMS_AND_CONDITIONS_PAID_SERVICES = 'TERMS_AND_CONDITIONS_PAID_SERVICES',
  SUMMARY_CONTRACT = 'SUMMARY_CONTRACT',
  TECHNICAL_REPORT_CONTRACT = 'TECHNICAL_REPORT_CONTRACT',
  APE_CONTRACT = 'APE_CONTRACT',
  REQUEST_FOR_DEED_OF_ORIGIN_CONTRACT = 'REQUEST_FOR_DEED_OF_ORIGIN_CONTRACT',
  BOOKLET_DELEGATION = 'BOOKLET_DELEGATION',
  BOOKLET_DELEGATION_CONTRACT = 'BOOKLET_DELEGATION_CONTRACT',
  COLLABORATOR_CONTRACT = 'COLLABORATOR_CONTRACT',
  SURVEYOR_CONTRACT = 'SURVEYOR_CONTRACT',
  PARTNERSHIP_CONTRACT = 'PARTNERSHIP_CONTRACT',
  APE_SURVEY = 'APE_SURVEY',
  EXTRA_TEMPLATE = 'EXTRA_TEMPLATE',
  COST_SUMMARY_TEMPLATE = 'COST_SUMMARY_TEMPLATE',
}
